var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    strokeWidth: 1.5,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "#4F5962",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5544 16.4635C20.6316 16.4635 21.5048 15.5593 21.5048 14.4439C21.5048 13.3285 20.6316 12.4243 19.5544 12.4243C18.4772 12.4243 17.604 13.3285 17.604 14.4439C17.604 15.5593 18.4772 16.4635 19.5544 16.4635Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15229 20.5045C10.2295 20.5045 11.1027 19.6003 11.1027 18.4849C11.1027 17.3695 10.2295 16.4653 9.15229 16.4653C8.07512 16.4653 7.2019 17.3695 7.2019 18.4849C7.2019 19.6003 8.07512 20.5045 9.15229 20.5045Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 7.0392C16.7295 7.0392 17.6027 6.13499 17.6027 5.0196C17.6027 3.9042 16.7295 3 15.6523 3C14.5751 3 13.7019 3.9042 13.7019 5.0196C13.7019 6.13499 14.5751 7.0392 15.6523 7.0392Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95038 11.0792C5.02755 11.0792 5.90077 10.175 5.90077 9.05964C5.90077 7.94424 5.02755 7.04004 3.95038 7.04004C2.87322 7.04004 2 7.94424 2 9.05964C2 10.175 2.87322 11.0792 3.95038 11.0792Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5528 12.4243L16.9523 6.36552M7.85051 16.4635L5.25 11.0779M5.81937 8.09L13.3079 5.86304M11.1683 17.5546L17.6024 15.1171M5.90013 9.73151L17.6024 13.0975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModels);
export default __webpack_public_path__ + "static/media/models.50ff1e917bfca08d9439e9fa17d00d7a.svg";
export { ForwardRef as ReactComponent };